import RestrictedEventEmitter from './util/RestrictedEventEmitter.js'

// place holder for when we do need some global actions
export const investigationActions = new RestrictedEventEmitter({
  name: 'InvestigationActions',
  logActions: false,
  allowedActions: [
  ]
})
